import { type InsertableSection } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

/**
 * Extracts the insertable portions of an assistant message's content using the
 * BE-provided `insertable_sections` indices. Each section's `start` and `end`
 * are character offsets into the original content string.
 *
 * When `insertableSections` is undefined, empty, or yields no non-empty slices,
 * returns `undefined` so the caller can fall back to the full content.
 *
 * @param content       The full message content string.
 * @param insertableSections  Array of `{start, end}` index pairs from the FINAL_RESPONSE.
 * @returns The concatenated insertable content, or `undefined` if not applicable.
 */
export function extractInsertableContent(
	content: string,
	insertableSections: InsertableSection[] | undefined,
): string | undefined {
	if (!insertableSections || insertableSections.length === 0 || !content) {
		return undefined;
	}

	const extractedSections = insertableSections
		.filter((section) => section.start >= 0 && section.end > section.start)
		.map((section) => content.slice(section.start, section.end).trim())
		.filter((s) => s.length > 0);

	return extractedSections.length > 0 ? extractedSections.join('\n\n') : undefined;
}
